import { Alert, Snackbar, useTheme } from "@mui/material";
import { useTranslator } from "../i18n/translator.ts";

interface SnackbarProps {
  id: number;
  open: boolean;
  message: string;
  severity: "success" | "error";
  onClose: () => void;
}

export const SnackbarComponent = ({
  id,
  open,
  message,
  severity,
  onClose,
}: SnackbarProps) => {
  const theme = useTheme();
  const translator = useTranslator();
  return (
    <Snackbar
      key={id}
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        "&.MuiSnackbar-root": { top: theme.spacing(10) },
      }}
    >
      <Alert
        severity={severity}
        onClose={onClose}
        closeText={translator("close")}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
